import { render, staticRenderFns } from "./Mouse.vue?vue&type=template&id=04536818&scoped=true&"
import script from "./Mouse.vue?vue&type=script&lang=js&"
export * from "./Mouse.vue?vue&type=script&lang=js&"
import style0 from "./Mouse.vue?vue&type=style&index=0&id=04536818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04536818",
  null
  
)

export default component.exports